export default __webpack_public_path__ + "static/media/avatar-1.0401c91f.jpg";